export const DOMAIN_API_EMAIL_TEMPLATE = {
  to: 'support@domain.com.au',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - API Integration',
  body: `Hello Domain API Team

Could you please enable Snug as an upload destination for our agency for the Domain API Account(s):

- [Enter your Domain Account ID here]
- [Enter your API Key details here]

Please note: This requires Paid Plan & Integrations Bundle.

Please assign the Domain API credentials and provide it to us.

Thank you,

Head of Property Management`,
}
